import * as Sentry from "@sentry/react"
import { StrictMode } from "react"
import { ThemeProvider } from "next-themes"
import { BrowserRouter } from "react-router-dom"
import { I18nextProvider } from "react-i18next"
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"

import { TooltipProvider } from "@/components/ui/tooltip"
import { ToastProvider } from "@/components/ui/toast-provider"
import { AppRouter } from "@/app/router"
import { ProfileThemeSync } from "@/components/app/profile-theme-sync"
import { UpgradePromptProvider } from "@/providers/upgrade-prompt-provider"
import { AuthProvider } from "@/lib/auth"
import { ErrorBoundary } from "@/components/error-boundary.tsx"
import i18n from "@/lib/i18n"

export default function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>} showDialog>
      <StrictMode>
        <I18nextProvider i18n={i18n}>
          <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
            <AuthProvider>
              <ProfileThemeSync />
              <BrowserRouter>
                <TooltipProvider>
                  <UpgradePromptProvider>
                    <ErrorBoundary
                      fallback={
                        <div className="p-8 text-center">
                          Something broke. Check console.
                        </div>
                      }
                    >
                      <AppRouter />
                    </ErrorBoundary>
                    <ToastProvider />
                  </UpgradePromptProvider>
                </TooltipProvider>
              </BrowserRouter>
            </AuthProvider>
          </ThemeProvider>
        </I18nextProvider>
        <Analytics />
        <SpeedInsights />
      </StrictMode>
    </Sentry.ErrorBoundary>
  )
}
